<template>
  <b-card>
    <b-card-header :class="ordtypeclass">
      <b-row v-if="order.order_type.id==1" style="background-color: #FFFDAE;"><b-col>Delivery</b-col></b-row>
      <b-row v-else-if="order.order_type.id==3" style="background-color: #E8A9FF;"><b-col>Counter</b-col></b-row>
      <b-row v-else-if="order.order_type.id==4" style="background-color: #C0FCC0;"><b-col>Dine In</b-col></b-row>
      <b-row v-else style="background-color: #7DA5FF;"><b-col>Pickup</b-col></b-row>
      <b-row>
        <b-col cols="4"><span class="full-only">Order: </span><b class="ord-num">{{ order.order_number }}</b></b-col>
        <b-col v-if="order.customer && order.order_type.id!=4" style="text-align: right;">
          <span class="full-only">Customer: </span><b>{{ order.customer.name }}<span v-if="order.customer.phone"> - {{ order.customer.phone | toUSPhoneNumber}}</span></b>
        </b-col>
        <b-col v-else style="text-align: right;">Table: <b>{{ order.table_number }}</b></b-col>
      </b-row>
      <b-row v-if="order.order_type.id==1">
        <b-col>Address: <b>{{ order.customer.delivery_address }}</b></b-col>
      </b-row>
      <b-row class="full-only" v-if="order.order_type.id!=4">
        <b-col cols="8">Pickup time: <b>{{ order.pickup_time | dateFormat }}</b></b-col>
        <b-col v-if="[1,2,5].includes(order.order_type.id)" cols="4" style="text-align: right;">SMS sent: <b>{{ order.sms_success }}</b></b-col>
      </b-row>
      <b-row class="sm-only" v-if="order.order_type.id!=4">
        <b-col cols="8">Pickup: <b>{{ order.pickup_time | dateFormatShort }}</b></b-col>
        <b-col v-if="[1,2,5].includes(order.order_type.id)" cols="4" style="text-align: right;">SMS: <b>{{ String(order.sms_success).substr(0,1).toUpperCase() }}</b></b-col>
      </b-row>
      <b-row v-if="order.order_type.id==4">
        <b-col>Order Date: <b>{{ order.date_created | dateFormat }}</b></b-col>
      </b-row>
    </b-card-header>
    <b-list-group v-for="orderline in order.order_lines" :key="orderline.id" flush>
      <b-list-group-item v-if="orderline.item.is_giftcard">
        <b-row>
          <b-col>
            <b>{{ orderline.quantity }} x {{ orderline.item.name }}</b>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="font-size: 90%;">
            <span v-if="orderline.gift_card_acc_no.length>0">
              <b-icon v-if="orderline.gift_card_trans_status==1" class="mr-2" icon="check-circle" variant="success"></b-icon>
              <b-icon v-else class="mr-2" icon="exclamation-circle" variant="danger"></b-icon>
              Card # {{ orderline.gift_card_acc_no }}
            </span>
            <span v-else>NEW CARD</span>
            &nbsp;{{ orderline.gift_card_topup_amount | toCurrency }}
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item v-else>
        <b-row>
          <b-col><b>{{ orderline.quantity }} x {{ orderline.item.name }}</b></b-col>
        </b-row>
        <div v-for="option of orderline.options" :key="option.id">
          <b-row cols="1">
            <b-col>
              <span v-for="(optionitem, index) of option.options" :key="optionitem.id">
                <span v-if="index != 0">, </span><span style="font-size: small;">{{ optionitem.name }}</span>
              </span>
            </b-col>
          </b-row>
        </div>
        <b-row cols="1"><b-col>{{ orderline.notes }}</b-col></b-row>
      </b-list-group-item>
    </b-list-group>
    <b-card-footer v-if="statusoptions">
      <b-row>
        <b-col cols="8">Notes: {{ order.notes }}</b-col>
        <b-col cols="4"><a :href="'https://dashboard.stripe.com/payments/'+order.payment_intent_id" target="_blank" style="float:right;">Payment</a></b-col>
      </b-row>
      <b-row cols="2">
        <b-col >
          <b-form-select
            size="sm"
            v-model="selected_status"
            :options="statusoptions"
            v-on:change="verifyNotification(order.id, order.location.id, selected_status, order.how_taken)">
          </b-form-select>
        </b-col>
        <b-col style="text-align: right;">Total: <b>{{ order.total | toCurrency }}</b></b-col>
      </b-row>
      <b-row class="mt-2">
        <!-- Show Order Ready! button if status is "Paid" & How taken = "Web" -->
        <b-col sm="12" md="3" class="mt-1" v-if="selected_status==6 && order.how_taken=='Web'">
          <b-button block variant="outline-success" @click="verifyNotification(order.id, order.location.id, 7, order.how_taken)">Order Ready!</b-button>
        </b-col>

        <!-- <b-col sm="12" md="4" class="mt-1" v-if="order.transaction.length>0 && order.transaction[0].payment_method!=1">
          <b-button block variant="outline-primary" @click="openReceiptURL(order)">Show Receipt</b-button>
        </b-col> -->

        <!-- Show "Complete Order" button if the status is either "Paid" or "Ready to Collect" -->
        <b-col sm="12" md="3" class="mt-1" v-if="selected_status==6 || selected_status==7">
          <b-button block variant="outline-primary" @click="verifyNotification(order.id, order.location.id, 8, order.how_taken)">Complete</b-button>
        </b-col>

        <!-- Show Collect Payment button if status is "Placed" -->
        <b-col sm="12" md="3" class="mt-1" v-if="selected_status==3">
          <b-button block variant="outline-success" @click="emitOrderToPay()">Pay Now</b-button>
        </b-col>

        <!-- Show Open Order button if order has no accompanying Transaction" -->
        <b-col sm="12" md="3" class="mt-1" v-if="order.transaction.length==0">
          <b-button block variant="outline-info" @click="openOrder()">Open Order</b-button>
        </b-col>

        <b-col sm="12" md="3" class="mt-1" v-if="voidable">
          <b-button block variant="outline-danger" @click="confirmVoidOrder()">Void Order</b-button>
        </b-col>

        <!-- Show Print Receipt button -->
        <b-col sm="12" md="3" class="mt-1">
          <b-button block variant="outline-secondary" @click="printCheck(order.id)">Print Check</b-button>
        </b-col>

      </b-row>
      <b-alert
        v-model="noReceiptAlert"
        :show="5"
        class="position-fixed fixed-bottom m-0 rounded-0"
        style="z-index: 2000;"
        variant="info"
        dismissible
        >
        There is no receipt associated with this order.
      </b-alert>
    </b-card-footer>

  </b-card>
</template>

<script>
export default {
  name: 'OrderInfo',
  props: ['order', 'statusoptions'],
  data() {
    return {
      noReceiptAlert: false,
      selected_status: 0,
    }
  },

  mounted() {
    this.selected_status = this.order.order_status.id;
  },

  watch: {
    order: function() {
      this.selected_status = this.order.order_status.id;
    }
  },

  computed: {
    voidable: function() {
      var v = true;
      if (Object.keys(this.order.transaction).length>0) {
        // If the first transaction is a remote card payment - not voidable
        if (this.order.transaction[0].payment_method==2) {
          v = false;
        } else {
          for (const t of this.order.transaction) {
            // If there is a captured terminal card payment associated - not voidable
            if (t.captured==true && t.payment_method==3) {
              v = false;
            }
          }
        }
      }
      return v;
    },

    ordtypeclass() {
      switch (this.order.order_type.id) {
        case 1:
          return 'delclass';
        case 3:
          return 'countclass';
        case 4:
          return 'dineinclass';
        default:
          return 'pckupclass';
      }
    }
  },

  methods: {
    emitOrderToPay() {
      this.$emit('emit-pay-order', this.order);
    },

    openOrder() {
      this.$router.push({ name: 'PlaceOrder', params: { vendorId:this.order.vendor_id, existOrder: this.order }});
    },

    confirmVoidOrder() {
      this.$bvModal.msgBoxConfirm('This will mark order #'+this.order.order_number+' as Voided and delete any associated Transactions, do you want to continue?' )
        .then(value => {
          if (value==true) {
            this.voidOrder()
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    async voidOrder() {
      this.showoverlay = true;
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      try {
        const { data } = await this.$api.delete('orders/'+this.order.id+'?void=True', config );
        if (data.success == true) {
          this.$emit('emit-fetch-orders');
        } else {
          console.log('error');
        }
      } catch (err) {
        var desc = 'There was a problem voiding the order, please try again later.';
        if (err.response.data.description=='payment_intent_unexpected_state') {
          desc = 'Unable to void. Stripe payment in unexpected state. Try a refund instead or access your Stripe account for more info.';
        }
        this.$bvToast.toast(desc, {
          title: 'Order Void Failed',
          solid: true,
          variant: 'danger',
          toaster: 'b-toaster-bottom-right'
        })
      }
    },

    async printCheck() {
      this.showoverlay = true;
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      try {
        const { data } = await this.$api.get('orders/'+this.order.id+'/printqueue/4', config);
        if (data.success == true) {
          this.$bvModal.msgBoxOk('Print Check Order Was Sent To The Print Queue.', {
            title: 'Success!',
            centered: true
          })
      } else {
        // If the print request to the api failed, tell the user to try again
        this.$bvModal.msgBoxOk('There was a problem submitting the print request for this order, please try again.', {
          title: 'Error Submitting Print Request',
          centered: true
        })
      }
      } catch (err) {
        this.$bvModal.msgBoxOk('There was a problem submitting the print request for this order, please try again.', {
          title: 'Error Submitting Print Request',
          centered: true
        })
      }
    },

    verifyNotification(orderid, locationid, orderstatus, how_taken) {
      if (orderstatus == 7 && how_taken=='Web') {
        // Show modal to confirm alert should be sent if status is Ready for Collection
        this.notification = ''
        this.$bvModal.msgBoxConfirm('Do you want to send an SMS notification to the customer?', {
          centered: true,
          okTitle: 'Yes',
          cancelTitle: 'No'
        })
        .then(value => {
          this.notification = value
          if (value==false) {
            return;
          } else if (value==true) {
            this.updateOrderStatus(orderid, locationid, orderstatus);
          }
        })
        .catch(err => {
          console.log(err);
        })
      }
      else {
        this.updateOrderStatus(orderid, locationid, orderstatus);
      }
    },

    openReceiptURL(order) {
      if (order.transaction.length==0) {
        this.noReceiptAlert = true;
      } else {
        window.open(order.transaction[0].transaction_receipt, '_blank');
      }
    },

    async updateOrderStatus(orderid, locationid, orderstatus) {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "order_status": orderstatus
      };

      // update order with status of 'ready'
      const { data } = await this.$api.patch('locations/'+locationid+'/orders/'+orderid,
        body,
        config
      );
      if (data.success == true) {
        this.$emit('emit-fetch-orders');
        if (data.sms_status=='Sent') {
          this.$bvModal.msgBoxOk('Order Updated and Notification Sent to Customer.', {
            title: 'Success!',
            centered: true
          })
        }
      } else {
        // If error was with updating order show this error, if it was with sending notification, send a differnt one
        this.$bvModal.msgBoxOk('There was a problem updating the order, please try again.', {
          title: 'Error updating order',
          centered: true
        })
      }
    },
  },
}
</script>

<style>

  @media (max-width: 359px) {
    .ord-num {
      font-size: 95%;
    }
  }

  .delclass { background-color: #FFFDAE; }
  .countclass { background-color: #E8A9FF; }
  .dineinclass { background-color: #C0FCC0; }
  .pckupclass { background-color: #7DA5FF; }

</style>
